<template>
  <div class="bf-page">
    <slot></slot>
    <section class="bf-page__section bf-section--last bf-section-last">
      <div class="bf-section-last__container">
        <div class="page-container">
          <!--          <div class="bf-section-last__row">-->
          <!--            <div class="bf-section-last__col">-->
          <!--              <img class="bf-section-last__img" src="/img/black-friday/bf-section-last-img-1.png" alt="tools image" />-->
          <!--            </div>-->
          <!--            <div class="bf-section-last__col">-->
          <!--              <div class="bf-section__form-wrap">-->
          <!--                <template v-if="!isAlreadySubscribed">-->
          <!--                  <span class="bf-section__form-title">{{ $t('bf_page_form_title') }}</span>-->
          <!--                  <span class="bf-section__form-subtitle">{{ $t('bf_page_form_subtitle') }}</span>-->
          <!--                </template>-->
          <!--                <black-friday-form class="bf-section__form" target="page"></black-friday-form>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="bf-section-last__row">
            <div class="bf-section-last__col">
              <div class="bf-section-last__text-wrap">
                <span class="bf-section-last__title">{{ $t('bf_section_last_title_1') }}</span>
                <span class="bf-section-last__text" v-html="$t('bf_section_last_text_1')"></span>
              </div>
            </div>
            <div class="bf-section-last__col">
              <div class="bf-section-last__text-wrap">
                <span class="bf-section-last__title">{{ $t('bf_section_last_title_2') }}</span>
                <span class="bf-section-last__text" v-html="$t('bf_section_last_text_2')"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import BlackFridayForm from '@/components/promo-pages/BlackFridayForm'

export default {
  name: 'BlackFriday',
  // components: { BlackFridayForm },
  data () {
    return {
      imagesCount: 20,
      loadedImagesCount: 0,
      currentPhotoIndex: 0,
      isLoading: true
    }
  },
  computed: {
    ...mapState({
      language: state => state.translation.language,
      userFromServer: state => state.user
    }),
    userData () {
      return this.userFromServer?.['user_data']
    },
    isAlreadySubscribed () {
      return !!+this.userData?.subscriber?.['black_friday']
    }
  },
  methods: {
    imageLoadedCallback () {
      this.loadedImagesCount++
      if (this.loadedImagesCount === this.imagesCount) {
        this.isLoading = false
      }
    },
    startTicker () {
      setInterval(() => {
        this.currentPhotoIndex++

        if (this.currentPhotoIndex === this.imagesCount) {
          this.currentPhotoIndex = 0
        }
      }, 50)
    }
  },
  watch: {
    // isLoading (value) {
    //   if (!value) {
    //     this.startTicker()
    //   }
    // }
  },
  mounted () {
    window.dispatchEvent(new CustomEvent('mountedBlackFriday'))
  }
}
</script>

<style scoped lang="sass">
.page-container
  position: relative

.bf-section-last
  //margin-top: 30px

  +mmin($tablet)
    //margin-top: 60px
    //padding-top: 110px

  .bf-section__form-wrap
    display: block
    max-width: 100%
    min-width: 100%

    +mmin($tablet)
      margin-top: 180px
      max-width: 330px
      min-width: 330px

.bf-section-last__container
  position: relative
  background: url('/img/black-friday/bf-section-last-img-2.png'), #0B0C10
  background-repeat: no-repeat
  background-position: bottom center
  background-size: 150%
  padding-bottom: 60%

  +mmin($tablet)
    background-position: bottom right
    background-size: contain
    padding-bottom: 37%

  +mmin($container)
    background-size: auto
    padding-bottom: 520px

.bf-section-last__row
  display: flex
  flex-wrap: wrap
  padding-top: 65px

.bf-section-last__col
  max-width: 100%
  flex: 0 0 auto

  +mmin($tablet)
    max-width: 50%
    flex: 0 0 50%

.bf-section-last__img
  pointer-events: none

  +mmin($tablet)
    transform: scale(1.5)

.bf-section-last__text-wrap
  width: 100%
  margin-bottom: 50px

  +mmin($tablet)
    width: 85%
    max-width: 540px

  &--margin
    margin-top: 50px

    +mmin($tablet)
      margin-top: 150px

.bf-section-last__title
  display: block
  color: #fff
  font-size: 18px
  text-transform: uppercase
  letter-spacing: 0.05em
  margin-bottom: 20px

  +mmin($tablet)
    font-size: 24px
    margin-bottom: 30px

.bf-section-last__text
  display: block
  font-size: 16px
  color: #909090

  +mmin($tablet)
    font-size: 18px

.bf-section-first
  position: relative
  background-color: #0B0C10
  overflow: hidden
  padding: 50px 0 45px

  +mmin($tablet)
    padding: 120px 0 115px

  &:before
    content: ''
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    background-image: url('/img/black-friday/shum.png')
    background-size: 120px 120px
    background-repeat: repeat
    pointer-events: none
    mix-blend-mode: screen

  &:after
    content: ''
    position: absolute
    width: 70%
    height: 100%
    border-radius: 50%
    background: #FF2F00
    opacity: 0.5
    filter: blur(110px)
    right: -15%
    bottom: -25%

    +mmin($tablet)
      filter: blur(250px)
      right: -30%
      bottom: -40%

.bf-section-first__content-wrap
  display: flex
  flex-flow: column
  width: 50%
  z-index: 1

  +mmin($tablet)
    width: 60%
    min-height: 550px

.bf-section__image-wrap
  position: absolute
  bottom: -5%
  right: -10%
  z-index: 1
  width: 85%
  max-width: 530px
  transform: scale(1.4)
  pointer-events: none

  +mmin($tablet)
    width: 95%
    max-width: 70%
    bottom: -8%

  +mmin($tablet--hor)
    bottom: -3%

  +mmin($container)
    right: -5%
    width: 50%

  video
    max-width: 100%

.bf-section-first__flex-wrap
  display: flex
  flex-flow: column

  +mmin($container)
    flex-flow: row wrap
    align-items: flex-end
    justify-content: space-between
    margin-top: auto

.bf-section__timer
  display: none
  width: auto
  margin-bottom: 20px

  +mmin($tablet)
    display: block

  ::v-deep
    .timer__container
      width: 90px

    .timer__title-wrap
      margin-bottom: 20px

    .timer__title
      +mmin($container)
        text-align: center

    .timer__number
      font-size: 26px

    .timer__text
      color: #fff
      opacity: .6
      font-size: 12px
      letter-spacing: 0.15em
      text-transform: uppercase
      margin-top: 1px

.bf-section__form-title
  display: block
  color: #e7e7e7
  text-transform: uppercase
  font-size: 20px
  line-height: 150%
  margin-bottom: 10px

.bf-section__form-subtitle
  display: block
  color: #909090
  font-size: 16px
  line-height: 130%
  margin-bottom: 30px

.bf-section__form-wrap
  display: none
  max-width: 330px
  min-width: 330px

  +mmin($tablet)
    display: block
    margin-bottom: 40px

  +mmin($container)
    margin-bottom: 0

  ::v-deep
    .col
      flex: 0 0 100%

      &:last-child
        display: none

    .col--full
      order: -1

    .control-box.control-box--phone
      width: 100%
      margin-right: 0

    .control-box.control-box--code
      margin-top: 20px

    .bf-form__wrapper
      max-width: 100%

    .bf-form__btn
      max-width: 100%

    .bf-form__phone-input
      width: 100%

    .bf-form-title
      color: #49D34F
      font-size: 20px
      font-weight: 400
      line-height: 150%
      text-align: left
      margin-bottom: 10px

    .bf-form-subtitle
      font-size: 16px
      font-weight: 400
      line-height: 130%
      text-align: left

::v-deep
  .bf-form-success
    margin: 0 0 20px
</style>

<!--styles for blocks on custom page-->
<style lang="sass" scoped>
::v-deep
  .page-container
    position: relative

  .bf-section-stats
    margin-top: 30px

    +mmin($tablet)
      margin-top: 60px

  .bf-section-product
    padding-top: 90px
    margin-top: 30px

    +mmin($tablet)
      margin-top: 60px

  .bf-section-product__image-wrap
    position: absolute
    width: calc(100% - 30px)
    max-width: 315px
    top: -15%
    left: 50%
    transform: translateX(-50%)

    +mmin($tablet)
      width: 41%
      max-width: unset
      right: 15px
      left: unset
      top: unset
      bottom: 0
      transform: unset

  .bf-section-product__container
    position: relative
    overflow: hidden
    background-color: #1A1B1D
    margin: 0 -15px

    +mmin($tablet)
      margin: 0

    &:before
      content: ''
      position: absolute
      left: 0
      top: 0
      width: 100%
      height: 100%
      background-image: url('/img/black-friday/shum.png')
      background-size: 120px 120px
      background-repeat: repeat
      pointer-events: none
      mix-blend-mode: screen

    &:after
      content: ''
      position: absolute
      width: 679px
      height: 400px
      border-radius: 50%
      background: rgba(255, 47, 0, 0.31)
      filter: blur(130px)
      left: -11px
      top: -85px

      +mmin($tablet)
        top: unset
        left: unset
        right: -150px
        bottom: -100px

  .bf-section-product__row
    display: flex
    flex-flow: column
    padding: 220px 25px 30px

    +mmin($tablet)
      flex-flow: row nowrap
      padding: 60px 65px

  .bf-section-product__col--left
    flex: 0 0 100%
    z-index: 1

    +mmin($tablet)
      flex: 0 0 70%

  .bf-section-product__col--right
    position: relative
    flex: 0 0 100%

    +mmin($tablet)
      flex: 0 0 30%

  .bf-product-header
    margin-bottom: 30px
    display: flex
    flex-flow: column

    +mmin($tablet)
      margin-bottom: 60px
      flex-flow: row nowrap

  .bf-product-header__subtitle
    display: block
    font-size: 14px
    color: #fff
    margin-bottom: 7px
    text-transform: uppercase

    +mmin($tablet)
      margin-bottom: 15px

  .bf-product-header__title
    font-size: 30px
    text-transform: uppercase
    color: #fff
    white-space: nowrap
    margin-left: -2px

    +mmin($tablet)
      font-size: 64px
      margin-left: -5px

  .bf-product-header__list
    +list-unstyled
    display: flex
    flex-flow: row wrap
    flex-shrink: 0
    margin-top: 7px

    +mmin($tablet)
      flex-flow: column
      margin-left: 40px
      margin-top: 15px

  .bf-product-header__list-item
    font-size: 14px
    line-height: 150%
    color: #fff
    text-transform: uppercase
    margin-right: 3px

    &:not(:first-child)
      &:before
        content: '+ '
        color: $main-color

  .bf-product-body
    margin-bottom: 5px

    +mmin($tablet)
      margin-bottom: 45px

  .bf-product-body__list
    +list-unstyled
    display: flex
    align-items: stretch
    flex-flow: row wrap

  .bf-product-body__list-item
    display: flex
    flex-flow: column
    width: 50%
    min-width: 130px
    margin-bottom: 25px

    +mmin($tablet)
      width: 25%
      max-width: 150px
      min-width: 150px
      margin-right: 50px

  .bf-product-body__list-title
    text-transform: uppercase
    color: rgba(255, 255, 255, 0.5)
    margin-bottom: 10px
    font-size: 14px

    &--single
      color: #fff
      margin-bottom: 0

  .bf-product-body__list-number
    margin-top: auto
    font-size: 24px
    color: #fff
    display: flex
    align-items: baseline
    flex-shrink: 0

    +mmin($tablet)
      font-size: 30px

    span
      font-size: 18px
      margin-left: 5px
      margin-right: 5px

  .bf-product-footer
    display: flex
    align-items: flex-start
    padding-top: 30px
    border-top: 1px solid #909090

    +mmin($tablet)
      align-items: center
      padding-top: 0
      border-top: none

  .bf-product-footer__btn
    filter: drop-shadow(0px 12px 30px rgba(255, 47, 0, 0.5))

  .bf-product-footer__price-wrap
    display: flex
    flex-flow: column
    flex-shrink: 0
    margin-left: 20px

    +mmin($tablet)
      flex-flow: row wrap
      flex-shrink: initial
      align-items: center
      margin-left: 50px

  .bf-product-footer__price
    display: flex
    align-items: flex-start
    color: #fff
    letter-spacing: -0.03em
    font-size: 30px
    font-weight: 500
    line-height: 1

    +mmin(425)
      font-size: 36px

    +mmin($tablet)
      margin-right: 20px

    span
      font-size: 20px
      margin-left: 5px

      +mmin(425)
        font-size: 24px

  .bf-product-footer__price-old
    display: flex
    align-items: flex-start
    position: relative
    color: #909090
    font-size: 18px
    font-weight: 500
    width: max-content
    line-height: 1
    margin-top: 5px

    +mmin($tablet)
      font-size: 30px
      margin-top: 0

    span
      font-size: 12px
      margin-left: 5px

      +mmin($tablet)
        font-size: 18px

    &:before
      content: ''
      position: absolute
      width: 105%
      height: 2px
      background-color: $main-color
      top: 50%
      left: 50%
      transform: translate(-50%, 100%)
</style>
